<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col mt-2">
          <validated-form-textarea name="message" placeholder="Memo"
                                   v-model="message" :rows="2" :maxRows="8"
                                   :autofocus="true"
                                   :validator="$validator"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import gateway from '@/services/gateway'
  import ValidatedFormTextarea from '@/components/ValidatedFormTextarea'

  export default {
    components: {ValidatedFormTextarea},
    props: ['client'],
    data() {
      return {
        message: ''
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          gateway.post(`/clients/${this.client.id}/memos`, {message: this.message})
            .then(() => {
              this.$notifications.info('Memo on lisatud')
              this.$emit('done')
            })
        })
      },
    },
  }
</script>
